import { render, staticRenderFns } from "./BtnImportacaoLeilao.vue?vue&type=template&id=6a9eedac&"
import script from "./BtnImportacaoLeilao.vue?vue&type=script&lang=js&"
export * from "./BtnImportacaoLeilao.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports